import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Loader2, ArrowLeft, Mail } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Se o e-mail existir, um link de redefinição será enviado');
    } catch {
      toast.success('Se o e-mail existir, um link de redefinição será enviado');
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8" style={{ background: 'linear-gradient(180deg, #0a0a1a 0%, #111133 50%, #0a0a1a 100%)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">U-Clean</h1>
        </div>

        <Card className="border-white/10 bg-white/5 backdrop-blur-md shadow-2xl">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Mail className="h-5 w-5 text-purple-400" /> Esqueci minha senha
            </CardTitle>
            <CardDescription className="text-gray-400">
              {sent ? 'Verifique sua caixa de entrada' : 'Informe seu e-mail para receber o link de redefinição'}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="text-center space-y-4" data-testid="forgot-password-sent">
                <div className="w-16 h-16 rounded-full bg-purple-500/10 flex items-center justify-center mx-auto">
                  <Mail className="h-8 w-8 text-purple-400" />
                </div>
                <p className="text-sm text-gray-300">
                  Se o e-mail <strong className="text-white">{email}</strong> estiver cadastrado, você receberá um link para redefinir sua senha.
                </p>
                <p className="text-xs text-gray-500">O link expira em 1 hora.</p>
                <Link to="/login">
                  <Button variant="outline" className="mt-4 border-white/10 text-gray-300 hover:text-white" data-testid="back-to-login-btn">
                    <ArrowLeft className="h-4 w-4 mr-2" /> Voltar ao login
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
                <div>
                  <Label htmlFor="forgot-email" className="text-gray-300">E-mail</Label>
                  <Input
                    id="forgot-email"
                    type="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="bg-white/5 border-white/10 text-white placeholder:text-gray-600"
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 text-white" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
                  Enviar link de redefinição
                </Button>
                <div className="text-center">
                  <Link to="/login" className="text-sm text-purple-400 hover:underline">
                    <ArrowLeft className="h-3 w-3 inline mr-1" /> Voltar ao login
                  </Link>
                </div>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
